import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { useSetDisplaySurfaceCallback } from '../../utils/media';
import { North, Popup } from '../../utils/popups';
import { ScreenIcon, WindowIcon } from '../Icon';
import { PopupButton } from '../PopupButton';
import { StackContent } from '../Stack';
import { AbstractPopup } from './AbstractPopup';
function ShareScreenPopup({ resolve, ...props }) {
    const setDisplaySurface = useSetDisplaySurfaceCallback();
    return (_jsx(ShareScreenPopupRoot, { translateFn: North, ...props, children: _jsxs(StackContent, { children: [_jsx(PopupButton, { type: "button", onClick: () => {
                        setDisplaySurface('monitor');
                        resolve();
                    }, prependComponent: _jsx(ScreenIcon, {}), children: "Entire Screen" }), _jsx(PopupButton, { type: "button", onClick: () => {
                        setDisplaySurface('window');
                        resolve();
                    }, prependComponent: _jsx(WindowIcon, {}), children: "Window" }), _jsx(PopupButton, { type: "button", onClick: () => {
                        setDisplaySurface('browser');
                        resolve();
                    }, prependComponent: _jsx(WindowIcon, {}), children: "Browser tab" })] }) }));
}
const ShareScreenPopupRoot = styled(AbstractPopup) `
    --Popup_InitialOffsetY: -100%;
    --Popup_OffsetY: calc(-100% - 1rem);
    --Popup_InitialOffsetX: -50%;
    --Popup_X: max(calc(50% + 1rem), min(var(--Popup_AnchorX, 0rem), calc(100vw - 100% + 50% - 1rem)));

    --Popup_Width: 23.75rem;
    --Popup_MaxWidth: calc(var(--vw-100, 100vw) - 2rem);

    /* Setup */
    --Popup_InitialScale: 0.98;
    --Popup_BorderRadius: 2rem;
`;
const shareScreenPopup = Popup.create(ShareScreenPopup);
export function selectShareScreenSource(options = {}) {
    (async () => {
        try {
            options.onOpenPopup?.();
            await shareScreenPopup.pop({
                anchorRef: options.anchorRef,
            });
        }
        catch (_ignore) {
        }
        finally {
            options.onClosePopup?.();
        }
    })();
}
